export const colors = {
  text: '#000',
  White: '#fff',
  PrimaryDarkBlue: '#112b4a',
  PrimaryBrightBlue: '#25a9e0',
  PrimaryBrightBlueHover: '#24a0d0',
  BrightCyan: '#3cc8ff',
  PrimaryGray: '#ebedee',
  SecondaryBlue2: '#006eb6',
  SecondaryBlue2Hover: '#005d99',
  SecondaryBlue2Active: '#004f82',
  SecondaryGray3: '#c2cace',
  SecondaryGray4: '#d8dee0',
  ice: '#f1f5f7',
  footer: '#3e4a56',
  background: 'White',
};

export default {
  colors,
  breakpoints: ['43.75em', '75em'],
  fonts: {
    body: '"Averta", Arial, sans-serif',
    heading: '"Averta", Arial, sans-serif',
  },
  fontSizes: '10px',
  lineHeights: [1.13, 1.18, 1.25, 1.33, 1.44],
  fontWeights: {
    body: 400,
    heading: 700,
  },
  text: {
    heading: {
      fontWeight: 'heading',
      margin: 0,
    },
  },
  styles: {
    root: {
      // uses the theme values provided above
      fontFamily: 'body',
      fontWeight: 'body',
      fontSize: '2rem',
      lineHeight: 1.7,
      color: 'PrimaryDarkBlue',
      maxWidth: '160rem',
      minWidth: '37.5rem',
      mx: 'auto',
    },
    h1: {
      variant: 'text.heading',
      fontSize: ['4rem', null, '5rem'],
      lineHeight: [1.13, null, 1.2],
      color: 'PrimaryBrightBlue',
    },
    h2: {
      variant: 'text.heading',
      fontSize: '4rem',
      fontWeight: 'body',
      lineHeight: 1.25,
    },
    h3: {
      variant: 'text.heading',
    },
    p: {
      marginTop: 0,
      marginBottom: '2.4rem',
      a: {
        color: '#006EB6',
        ':hover': {
          color: '#1F3374',
        },
        ':active': {
          color: '#25A9E0',
        },        
      },
    },
  },
};
